export default __webpack_public_path__ + "static/media/FlatLogo.cca22eab.svg";